<template>
  <div>
    <div class="column is-narrow has-cursor-grab" v-if="canDrag">
      <i class="fal fa-grip-lines"></i>
    </div>
    <div class="column is-2 is-border-left is-border-right has-bg-light"
         v-if="imageValidation(document.path)">
      <img :src="document.path" alt="">
    </div>
    <div class="column">
      <label for="" class="label">Nom du fichier <span v-if="defaultNames && defaultNames.length && edit"> : sélectionner un nom par défaut</span></label>
      <div class="field has-addons">
        <div class="control is-expanded">
          <v-input v-if="!edit"
                   :id="'documentFileName-' + document.path"
                   :name="'documentFileName-' + document.path"
                   :model="document.filename"
                   :errors-bag="errors"
                   data-vv-value-path="val"
                   data-vv-as="Nom du fichier"
                   label=""
                   v-validate="'required|min:2'"
                   @input="val => document.filename = val">
          </v-input>
          <div v-if="defaultNames && defaultNames.length && edit">
            <!-- <label class="label">Sélectionner un nom par défaut</label>-->
            <multiselect :options="defaultNames"
                          v-model="defaultFileName"
                          @input="val => document.filename = val"
                          :placeholder="''"
                          class="multiselect multiselect--option-ico"></multiselect>
          </div>
        </div>

        <div class="control"
          v-if="defaultNames && defaultNames.length">
          <a class="button is-square is-grey is-inverted is-border tooltip"
             @click="edit = !edit"
             data-tooltip="Editer le nom">
            <i class="fal" :class="!edit ? 'fa-pen' : 'fa-save'"></i>
          </a>
        </div>
        <div class="control">
          <span class="button is-square is-grey is-inverted is-border tooltip"
             @click="download(document.path)"
             data-tooltip="Télécharger">
            <i class="fal fa-download"></i>
          </span>
        </div>
        <div class="control"
          v-if="!imageValidation(document.path)">
          <a class="button is-square is-grey is-inverted is-border tooltip"
             @click="openPreview(document)"
              data-tooltip="Aperçu">
            <i class="fal fa-external-link-alt"></i>
          </a>
        </div>
        <div class="control"
          v-if="imageValidation(document.path)">
          <a class="button is-square is-grey is-inverted is-border tooltip"
             @click="editDocument(document, index)"
              data-tooltip="Recadrer l'image">
            <i class="fal fa-crop"></i>
          </a>
        </div>
        <div class="control">
          <a class="button is-square is-grey is-inverted is-border tooltip"
             @click="deleteDocument(document)"
              data-tooltip="Supprimer">
            <i class="fal fa-trash-alt"></i>
          </a>
        </div>
      </div>
    </div>
    <div v-if="privacy" class="column is-2">
      <input type="radio"
             v-model="document.privacy"
             value="intern"
             :id="'intern-' + document.path"
             class="is-checkradio is-small is-info">
      <label class="label" :for="'intern-' + document.path">Privé</label>
      <br>
      <br>
      <input type="radio"
             v-model="document.privacy"
             value="public"
             :id="'public-' + document.path"
             class="is-checkradio is-small is-info">
      <label class="label" :for="'public-' + document.path">Public</label>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'UploadedFileItem',
    data () {
      return {
        edit: false,
        defaultFileName: null
      }
    },
    props: {
      document: {
        type: Object,
        required: true
      },
      defaultNames: {
        type: Array,
        default: () => []
      },
      privacy: {
        type: Boolean,
        required: false,
        default: false
      },
      canDrag: {
        type: Boolean,
        default: true
      },
      index: {
        type: Number,
        default: 0
      }
    },
    methods: {
      imageValidation (value) {
        if (!value) return
        let ext = value.split('.')
        if (ext[ext.length - 1].match(/(jpg|png|jpeg|gif)/g)) return true
        else return false
      },
      download (file) {
        let link = document.createElement('a')
        link.href = file
        link.target = '_blank'
        link.click()
      },
      openPreview (selectedDocument) {
        this.$emit('openPreview', selectedDocument)
      },
      editDocument (selectedDocument, index) {
        this.$emit('editDocument', {selectedDocument, index})
      },
      deleteDocument (document) {
        this.$emit('deleteDocument', {document})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/utils/UploadedFileItem.vue